import { render, staticRenderFns } from "./OverviewArea.vue?vue&type=template&id=24b3d889&scoped=true&"
import script from "./OverviewArea.vue?vue&type=script&lang=js&"
export * from "./OverviewArea.vue?vue&type=script&lang=js&"
import style0 from "./OverviewArea.vue?vue&type=style&index=0&id=24b3d889&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b3d889",
  null
  
)

export default component.exports